import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {


  constructor(private http:HttpClient) { }


  
getHammaddeler(){
  return this.http.get<any[]>(environment.apiUrl+"product");
}
getHammadde(id:any){
  return this.http.get<any>(environment.apiUrl+"product/"+id);
}



addHammadde(model:any){
return this.http.post(environment.apiUrl+"product",model);
}

editHammadde(model:any,id:any){
  return this.http.put(environment.apiUrl+"product/"+id,model);
  }

deleteHammadde(id:any){
  return this.http.delete(environment.apiUrl+"product/"+id);
  }


  copy(id:any){
  return this.http.get(environment.apiUrl+"product/copy/"+id);
  }


  download(id){
   
   
      return this.http.get(`${environment.apiUrl}product/file?id=`+id, { responseType: 'blob'});
  
  }
}
